import classNames from 'classnames';
import React from 'react';

import type { Page as PageType } from '../../types/entities';
import Blocks from '../blocks/Blocks';
import PageHeader from '../partials/PageHeader';
import PageMeta from '../partials/PageMeta';

import styles from '../../../styles/pages/page.module.css';

interface PageProps {
    page: PageType;
}

function Page({ page }: PageProps) {
    const { blocks = null, share = null } = page || {};

    return (
        <div className={styles.container}>
            <PageMeta {...share} />
            <div className={classNames(['page-inner', styles.inner])}>
                <PageHeader title={page.title} handle={page.handle} />
            </div>
            <div className={styles.blocks}>
                <Blocks page={page} blocks={blocks || []} blocksAreSections />
            </div>
        </div>
    );
}

export default Page;
